const data = {
    intro:"Hello, I’m",
    name: "Sandeep Budha",
    title: "👨‍💻 Developer + Designer",
    social: {
      youtube:"https://www.youtube.com/channel/UCyy7M1asH-tQZQoNEedOwag",
      github: "https://github.com/codegorkha",
      medium:"https://medium.com/@codegorkha",
      facebook: "https://www.facebook.com/codegorkha/",
      twitter: "https://twitter.com/CodeGorkha",
      insta:"https://www.instagram.com/codegorkha/",
      linkedin:"https://www.linkedin.com/in/code-gorkha-027876248/",
      email: "codegorkha@gmail.com",
    },
  
  
    app: {
      bol:"https://play.google.com/store/apps/details?id=com.codegurkha.bolchitra",
      wot: "https://play.google.com/store/apps/details?id=com.codegurkha.worldtour",
      aog:"https://play.google.com/store/apps/details?id=com.codegurkha.arabghar_user",
      som: "https://play.google.com/store/apps/details?id=com.codegurkha.samrajya",
      pot: "https://github.com/sandeepflutter",
      wotd:"https://drive.google.com/file/d/1DB8Ls6-yx0f5TdoyEXherLC0pl1kmnoK/view?fbclid=IwAR3i0c-Ie-SoibcZfMDQOcTpsKEnDcF129Q702RT299JkBo3zlu8BBKws_o",
      web:"https://www.ashrayaengineering.com.np/"
    },
  
    about: {
      descr1:"My name is Sandeep Budha. I am a Nepal-based application developer and designer who creates beautiful Apps. I make websites using HTML, CSS, and JavaScript, and I utilize Flutter to create stunning, responsive apps for desktop, mobile, and the web. I am a user of design programs like Adobe XD and Photoshop. I've also used Arduino to work on minor projects for an IOT project.",
      descr2:"KEEP MOVING FORWARD",
      descr3:"I'm open to freelance opportunities. Email me and we can talk if you want to talk to me about working with you.",
      descr4:"B.E. in Computer Science & Engineering \n Former IT Officer at\n Bhairabi Rural Municipality",
    },
  };
  
  export default data;
  